/**
 * Which paths a phone may open. Anything else redirects to mobile capture.
 *
 * Lives in its own module rather than inside `App.tsx` so it can be tested
 * without mounting the whole route tree, and because it has a contract with
 * the artifact-type registry that nothing else enforces: EVERY artifact type's
 * `detailRoutePath` has to be covered here.
 *
 * That contract is not theoretical. Moving `protocol` off `/notes/:id` onto its
 * own detail route on 2026-09-16 made every protocol unreachable on a phone -
 * search, recents, the graph and Bird citations all redirected to capture - and
 * nothing failed, because this list and the registry had no relationship beyond
 * somebody remembering. `__tests__/mobileRoutes.test.ts` is now that
 * relationship.
 */
export const MOBILE_SUPPORTED_PATH_PREFIXES = [
  '/m/',
  '/live',
  '/settings',
  '/onboarding',
  '/trash',
  '/audit',
  '/notes',
  '/protocols',
  '/collections',
  '/attachments',
  '/spreadsheets',
  '/links',
  '/equipment',
] as const;

export function isMobileSupportedPath(pathname: string): boolean {
  return MOBILE_SUPPORTED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix),
  );
}
